<template>
  <div class="flex flex-col h-auto">
    <div class="flex items-center justify-start bg-beige-academy-250 w-full py-2
    text-white text-left">
      <div class="text-base w-full px-6 md:px-40 font-sans-serif flex">
        <router-link class="pr-1" to="/teachers">
          {{$t('teacher.all')}}
        </router-link>
      </div>
    </div>
    <div class="flex flex-col top-0 mx-auto w-full h-auto">
      <div class="flex py-3 md:py-10 w-full px-3 lg:px-20 justify-around items-center
        blur z-20">
        <div class="flex items-center" v-if="student.user">
          <img :src="student.user.urlProfilePhoto" alt="foto profilo" id="photo"
              class="rounded-full w-20 md:w-28 transform group-hover:scale-105
              group-hover:border-orange-academy-150">
          <div class="flex flex-col justify-start ml-6 lg:ml-16">
            <h1 class="font-bold text-background-academy text-lg md:text-2xl lg:text-3xl uppercase
            transform group-hover:scale-105 w-auto flex" id="title">{{student.name}}</h1>
            <div class="flex text-left pt-2">
              <span class="text-md text-grey-academy-300 opacity-75 w-full pr-2">
                {{ student.qualification }}
              </span>
            </div>
            <div class="flex flex-col md:hidden font-sans-serif" v-if="student.user">
              <button class="flex items-center" v-if="student.user.facebook">
                <img src="@/images/facebook.svg" class="w-5 mr-4">
                <span>Facebook Link</span>
              </button>
              <button class="flex items-center mt-4" v-if="student.user.instagram">
                <img src="@/images/instagram.svg" class="w-5 mr-4">
                <span>Instagram Link</span>
              </button>
            </div>
            <student-statistics></student-statistics>
          </div>
        </div>
        <button class="bg-orange-academy-150 rounded-3xl px-3 lg:px-5 h-10 lg:h-16"
          @click="contact(user, student.user)" v-if="authenticated">
            <message-icon class="w-4 lg:w-7 text-white" />
        </button>
        <div class="flex-col hidden md:flex font-sans-serif" v-if="student.user">
          <button class="flex items-center" v-if="student.user.facebook">
            <img src="@/images/facebook.svg" class="w-8 mr-4">
            <span>Facebook Link</span>
          </button>
          <button class="flex items-center mt-4" v-if="student.user.instagram">
            <img src="@/images/instagram.svg" class="w-8 mr-4">
            <span>Instagram Link</span>
          </button>
        </div>
      </div>
      <div class="bg-white h-screen relative mb-10 z-10">
        <nav class="flex flex-col w-full flex-wrap z-50 sticky inset-y-0 top-0 justify-end h-auto">
          <router-link class="mr-1 w-20 h-20 flex flex-col
            justify-center items-center font-sans-serif border-2 border-orange-academy-150
            hover:bg-orange-academy-150 hover:text-white md:w-28 md:h-28"
            :to="pathDashboard"
            :class="$route.fullPath === pathDashboard ?
            'bg-orange-academy-150 text-white' : 'text-black'">
              <profile-icon />
              <span class="pt-2">{{ $t('teacher.info')}}</span>
          </router-link>
          <router-link class="mr-1 border-2 w-20 h-20 flex flex-col justify-center
            items-center hover:bg-orange-academy-150 hover:text-white md:w-28 md:h-28
            font-sans-serif border-orange-academy-150"
            :to="pathDashboard+'/masterclasses'"
            :class="$route.fullPath === pathDashboard+'/masterclasses' ?
            'bg-orange-academy-150 text-white' : 'text-black'">
              <masterclass-icon />
              <span class="pt-2">{{ $t('teacher.masterclasses')}}</span>
          </router-link>
        </nav>

        <section class="pb-20 absolute inset-0 h-auto mx-24">
            <router-view></router-view>
        </section>

        <modal resizable name="messageFormModal" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// import SoundWave from '@/components/graphics/SoundWave.vue';
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';
import { getStudentBySlug } from '@/services/StudentService';
import MessageIcon from '../components/graphics/MessageIcon.vue';
import MasterclassIcon from '../components/graphics/MasterclassIcon.vue';
import ProfileIcon from '../components/graphics/ProfileIcon.vue';
import StudentStatistics from '../components/students/StudentStatistics.vue';

export default {
  data() {
    return {
      student: {},
    };
  },

  components: {
    MessageIcon,
    MasterclassIcon,
    ProfileIcon,
    StudentStatistics,
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
      authenticated: 'auth/authenticated',
    }),

    pathDashboard() {
      return `/students/${this.student.slug}`;
    },
  },

  mounted() {
    this.getSelectedStudent();
  },

  mixins: [StreamFunctionsMixin],

  methods: {
    getSelectedStudent() {
      return getStudentBySlug(this.$route.params.slug).then((response) => {
        this.student = response.data;
        if (this.authenticated && this.user.id === this.student.user.id) {
          this.goToDashboard();
        }
      }).catch(() => {
        this.createNotification('error', this.$t('notifications.errorReload'));
      });
    },
  },

};
</script>

<style lang="scss" scoped>
  .shadow {
    --tw-shadow: 0 4px 6px -1px rgb(148, 67, 0), 0 2px 4px -1px rgb(148, 67, 0);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #A69185), var(--tw-ring-shadow, 0 0 #A69185),
    var(--tw-shadow);
  }
  .blur {
    background: rgba(255, 255, 255, 0.75);
    backdrop-filter: blur( 3px );
    -webkit-backdrop-filter: blur( 1px );
    --tw-shadow: 0 4px 6px -1px rgb(166, 145, 133), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000),
      var(--tw-shadow);
  }

</style>
